import { inject, Injectable } from '@angular/core';
import { PerformSyncNotifierService } from '../perform-sync-notifier/perform-sync-notifier.service';
declare let IdleDetector: any;

@Injectable({
    providedIn: 'root',
})
export class AppIdleDetectorService {
    private readonly syncnotifier: PerformSyncNotifierService = inject(PerformSyncNotifierService);

    private idleDetector: typeof IdleDetector;

    public get screenState(): 'locked' | 'unlocked' {
        return this.idleDetector?.screenState;
    }

    public get userState(): 'active' | 'idle' {
        return this.idleDetector?.userState;
    }

    constructor() {}
    async start() {
        await this.idleDetector.start();
        this.change();
    }

    detectFeature(): boolean {
        return 'IdleDetector' in window;
    }
    init() {
        this.idleDetector = new IdleDetector();
    }

    isIdleDtectionActive(): boolean {
        return !!this.idleDetector;
    }

    async requestPermission() {
        const result = await IdleDetector.requestPermission();
        if (result === 'granted') {
            return true;
        } else {
            return false;
        }
    }

    async permissionStatus(): Promise<PermissionState> {
        const status = await navigator.permissions.query({
            name: 'idle-detection' as any,
        });
        return status.state;
    }

    change() {
        this.idleDetector.addEventListener('change', () => {
            this.syncnotifier.registerIdleDetection(this.screenState, this.userState);
        });
    }
}
